import React from "react";

import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

import { t } from "@auto/services";
import KpiCard from "@src/reporting/components/KpiCard";
import ReportingWidget from "@src/reporting/components/ReportingWidget";
import useReportingResource from "@src/reporting/hooks/useReportingResource.mjs";
import { count } from "@src/reporting/model/reportingFormatters.mjs";
import { loadStatsSummary } from "@src/reporting/services/reportingApi.mjs";
import styles from "@src/reporting/Reporting.module.styl";

const PublicStatsSummaryWidget = () => {
  const resource = useReportingResource(
    loadStatsSummary,
    {
      key: "summary",
      initialData: {},
    },
  );

  const summary = resource.data || {};
  const cards = [
    [BadgeOutlinedIcon, t("stats.registeredVoters"), count(summary.registeredVoterCount)],
    [GroupsOutlinedIcon, t("stats.activeOperators"), count(summary.activeOperatorCount)],
    [LocationOnOutlinedIcon, t("stats.activeCenters"), count(summary.activeVotingCenterCount)],
    [LocationOnOutlinedIcon, t("stats.configuredCenters"), count(summary.votingCenterCount)],
  ];

  return (
    <ReportingWidget
      title={t("stats.applicantHighlights")}
      loading={resource.loading}
      error={resource.error}
      empty={resource.hasLoaded && !summary.id}
      emptyMessage={t("stats.noData")}
    >
      <div className={styles.kpiGridPublic}>
        {cards.map(([Icon, label, value]) => (
          <KpiCard key={label} icon={Icon} label={label} value={value} />
        ))}
      </div>
    </ReportingWidget>
  );
};

export default PublicStatsSummaryWidget;
